import { render, staticRenderFns } from "./PT431MemberOrderPayChangeParts.vue?vue&type=template&id=a487586e&"
import script from "./PT431MemberOrderPayChangeParts.vue?vue&type=script&lang=js&"
export * from "./PT431MemberOrderPayChangeParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports